<div class="modal-header">
  <div class="modal-title" tabindex="-1">
    {{ data.title | translate }}
  </div>
  <button
    type="button"
    class="wk-modal-close wk-button wk-button-icon wk-button-close"
    (click)="close()"
  >
    <span class="wk-icon-filled-close" aria-hidden="true"></span>
    <span class="wk-sr-only">Close</span>
  </button>
</div>
<div class="modal-body">
  <p>{{ data.message | translate }}</p>
</div>
<div class="modal-footer">
  <div class="wk-button-group wk-button-group-right">
    <button
      type="button"
      class="wk-button wk-button-text"
      (click)="close()"
    >
      {{ data.noLabel | translate }}
    </button>
    <button
      type="button"
      class="wk-button"
      (click)="close(true)"
    >
      {{ data.yesLabel | translate }}
    </button>
  </div>
</div>
